import IndexModel from "@/service/v1/sigap/IndexModel";
 
class NotaService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Nota' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    public getTipo(    ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/GetTipo')
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    public getStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public homologarNotaProfile( id: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url  + '/Profile/'+ id + '/Homologar' )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public solicitarRevisaoProfile( id: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url  + '/Profile/'+ id + '/Revisao' , {}   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
  
    public liberarNota( id: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url  + '/'+ id + '/Liberar' )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
  
    public liberarNotaFilter( disciplinaId: any, tipo : any , pelotao: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put(  `${this.url}/Liberar?disciplinaId=${disciplinaId}&tipo=${tipo}&pelotao=${pelotao}` )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
    
    public arquivarNotaFilter( disciplinaId: any, tipo : any , pelotao: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put(  `${this.url}/Homologar?disciplinaId=${disciplinaId}&tipo=${tipo}&pelotao=${pelotao}` )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
    
 
    public cadastrarLote(   dados: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url + '/Lote'  , dados   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }


}
  
export default NotaService; 